import { createContext, useContext } from 'react';

const BitkitPortalContext = createContext({ disablePortal: false });

export const usePortalContext = () => useContext(BitkitPortalContext);

export default BitkitPortalContext;
